import { LazyLoad } from 'app/utils';

export const CommerceItemCategorySortPage = LazyLoad(() => import('./index'), (module) => module.CommerceItemCategorySortPage);
